/**
 * <SchoolAssessmentRowSkeleton> — la forme de `<SchoolAssessmentRow>` pendant un chargement.
 *
 * Posé par le squelette de l'accueil et par « Suivi » quand les contrôles arrivent après le reste
 * de la page : le picto de la matière (`SUBJECT_ICON_SIZE`), le libellé de tête, le titre, puis la
 * date et la chip du compte à rebours.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardListRow } from "../CardList"
import { SUBJECT_ICON_SIZE } from "./SchoolAssessmentRow"

export function SchoolAssessmentRowSkeleton() {
    return (
        <CardListRow>
            <Row gap="3" align="center">
                <Skeleton shape="circle" size={SUBJECT_ICON_SIZE} />
                <Stack gap="1" style={styles.body}>
                    <Skeleton textSize="text-sm" width={110} />
                    <Skeleton textSize="text-md" width={200} />
                    <Row gap="2" align="center">
                        <Skeleton textSize="text-sm" width={50} />
                        <Skeleton shape="chip" width={40} />
                    </Row>
                </Stack>
            </Row>
        </CardListRow>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flex: 1, flexShrink: 1 },
}))
